import type { ReactElement, ReactNode } from "react";
import { ObjektMenue } from "./ObjektMenue.js";
import type { ObjektMenueProps } from "./ObjektMenue.js";
import { ObjektVerweis, verweisTexte } from "./ObjektVerweis.js";
import type { ObjektVerweisProps } from "./ObjektVerweis.js";
import type { ObjektPanelWege } from "./ObjektPanelKontext.js";
import "./ErsteSpalte.css";

/** Die Knöpfe eines Objekts (Anatomie 1.2, P4): Verweis → Umschalter → „⋯“. */
export type ObjektKnoepfe = { verweis?: ObjektVerweisProps; umschalter?: ReactNode; menue?: ObjektMenueProps };

/** Die eine Folge der Knöpfe — im Fuß wie in der ersten Spalte. */
function Knoepfe(k: ObjektKnoepfe): ReactElement {
  return (
    <>
      {k.verweis !== undefined && <ObjektVerweis {...k.verweis} />}
      {k.umschalter}
      {k.menue !== undefined && <ObjektMenue {...k.menue} />}
    </>
  );
}

/**
 * Der Slot `fuss` eines `Objekt` aus seinen Knöpfen; ohne vorhandenen Teil `undefined` — kein leerer Träger, keine leere
 * Fußzeile (PF17). `w` sind die Wege der Stelle (`useObjektPanel`); sie entscheiden, ob der Verweis einen Knopf hat.
 */
export function objektFuss(w: ObjektPanelWege, k: ObjektKnoepfe): ReactElement | undefined {
  const texte = k.verweis === undefined ? {} : verweisTexte(w, k.verweis);
  const mitVerweis = texte.panel !== undefined || texte.sprung !== undefined;
  const mitMenue = (k.menue?.eintraege.length ?? 0) > 0;
  const mitUmschalter = k.umschalter !== null && k.umschalter !== undefined && k.umschalter !== false && k.umschalter !== "";
  if (!mitVerweis && !mitUmschalter && !mitMenue) return undefined;
  return (
    <Knoepfe {...(mitVerweis && k.verweis !== undefined ? { verweis: k.verweis } : {})}
      {...(mitUmschalter ? { umschalter: k.umschalter } : {})}
      {...(mitMenue && k.menue !== undefined ? { menue: k.menue } : {})} />
  );
}

/**
 * Die schmale erste Spalte einzeiliger Zeilen (Entscheid 115): Verweis — immer `klein` (W-1) —, Umschalter, „⋯“, dieselbe
 * Folge wie im Fuß. Nur Anordnung; die Maße kommen vom Element.
 */
export function ErsteSpalte(p: { verweis?: Omit<ObjektVerweisProps, "klein">; umschalter?: ReactNode; menue?: ObjektMenueProps }):
    ReactElement {
  return (
    <span className="erstespalte">
      <Knoepfe {...(p.verweis === undefined ? {} : { verweis: { ...p.verweis, klein: true } })}
        {...(p.umschalter === undefined ? {} : { umschalter: p.umschalter })} {...(p.menue === undefined ? {} : { menue: p.menue })} />
    </span>
  );
}
